import React from 'react'

import { useContactSales } from 'components/banner/useContactSales'
import type { IButtonPropsType } from 'components/uiKit/Button'
import Button from 'components/uiKit/Button'
import { t } from 'services/Translation'

interface IContactSalesButtonProps extends Omit<IButtonPropsType, 'children'> {
  email: string
  name: string
}

const ContactSalesButton: React.FC<IContactSalesButtonProps> = ({
  email,
  name,
  ...buttonProps
}) => {
  const { mount, open } = useContactSales({ email, name })

  const handleClick = () => {
    if (window.PLATFORM.PlatformName === 'Parta.io') {
      window.open('https://buy.stripe.com/8x26oIb8z0kCerR6Ly4wM0v', '_blank')
      return
    } else {
      open()
    }
  }

  return (
    <>
      <Button
        name='contactSales'
        onClick={handleClick}
        styleType='secondary'
        inheritColor
        {...buttonProps}
      >
        {t('notify.contactSales')}
      </Button>
      {mount}
    </>
  )
}

export default ContactSalesButton
